import { Component, OnInit, Inject } from "@angular/core";
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from "@angular/material";
import { CoreLanguageService } from "../../services/language.service";

@Component({
  selector: "ya-discardbasketdialog",
  templateUrl: "./discardBasketDialog.component.html",
  styleUrls: ["./discardBasketDialog.component.scss"]
})
export class DiscardBasketDialogComponent implements OnInit {
  public allowBasketModification: boolean = true;
  constructor(public bottomSheetRef: MatBottomSheetRef<DiscardBasketDialogComponent>
    , @Inject(MAT_BOTTOM_SHEET_DATA) public data: any
    , private _coreLanguageService: CoreLanguageService) {
    const me = this;
    me.allowBasketModification = true;
  }

  ngOnInit() {
  }

  public setSubHeaderContent() {
    const me = this;
    return me._coreLanguageService.value("phResetBasketWarning_SubHeaderContent").replace("{locationName}", me.data.locationName);
  }

  public backtoBasket() {
    const me = this;
    me.bottomSheetRef.dismiss(false);
  }

  public clearBasketItems() {
    const me = this;
    me.bottomSheetRef.dismiss(true);
  }

}
